import {
  ExternalRouteRef,
  RouteRef,
  SubRouteRef,
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/core-plugin-api';

export enum RoutesIds {
  projects = 'projects',
  project = 'project',
  projectChat = 'projectChat',
  projectDocument = 'projectDocument',
}

enum ExternalRoutesIds {
  agentContext = 'agentContext',
  chat = 'chat',
  initiative = 'initiative',
  surface = 'surface',
}

// root route
export const projectsRouteRef = createRouteRef({ id: RoutesIds.projects });

export const rootRouteRef = projectsRouteRef;

// sub-routes
export const projectRouteRef = createSubRouteRef({
  id: RoutesIds.project,
  parent: rootRouteRef,
  path: '/:id',
});

export const projectChatRouteRef = createSubRouteRef({
  id: RoutesIds.projectChat,
  parent: rootRouteRef,
  path: '/:id/chats/:chatId',
});

export const projectDocumentRouteRef = createSubRouteRef({
  id: RoutesIds.projectDocument,
  parent: rootRouteRef,
  path: '/:id/documents/:documentId',
});

export const agentContextRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.agentContext,
  optional: true,
});

export const chatRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.chat,
  params: ['id'],
  optional: true,
});

export const initiativeRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.initiative,
  params: ['id'],
  optional: true,
});

export const surfaceRouteRef = createExternalRouteRef({
  id: ExternalRoutesIds.surface,
  params: ['id'],
  optional: true,
});

// default routes/routes to be used by other plugins
export const Routes = {
  projects: projectsRouteRef,
  project: projectRouteRef,
  projectChat: projectChatRouteRef,
  projectDocument: projectDocumentRouteRef,
} satisfies Record<RoutesIds, SubRouteRef | RouteRef>;

export const ExternalRoutes = {
  agentContext: agentContextRouteRef,
  chat: chatRouteRef,
  initiative: initiativeRouteRef,
  surface: surfaceRouteRef,
} satisfies Record<ExternalRoutesIds, ExternalRouteRef>;
